import { useImportContext } from '../../../../../../components/csv-import/ui/components/import-context';
import { ConfigStepFooter } from '../../../../../../components/csv-import/ui/components/steps/create-config-step/create-config-step';

type PurchaseOrderForm = {
  inventoryWarehouse?: string;
};

export const PurchaseOrderConfigStepFooter = () => {
  const { form } = useImportContext();
  const typedForm = form as PurchaseOrderForm;

  return <ConfigStepFooter isInitImportBtnDisabled={!typedForm?.inventoryWarehouse} />;
};
